import { SpinnerVisibilityService } from "ng-http-loader";
import {
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit,
    OnChanges,
    SimpleChanges,
    ViewChild,
    ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import mapboxgl from 'mapbox-gl';
import moment from "moment";
import { SubSink } from "subsink";
import {
    MapboxGLButtonControl,
    PitchToggle,
} from "src/app/air/modules/common/utility/custom-map-control";
// import { AppRoutes } from "../../../../modules/common/lib/api-constant";
import { catchError, first, forkJoin, Observable, switchMap, tap, throwError } from "rxjs";
import { TrackingService } from "../../air/modules/common/service/tracking/tracking.service";
import { ShipmentService } from "../../air/modules/common/service/shipments/shipment.service";
import { FilterService } from "../../air/modules/common/service/filter/filter.service";
import { VesselService } from "../../air/modules/common/service/vessel/vessel.service";
import {
    AuthService,
    CommonService,
    StorageService,
} from "../../air/modules/common/service";
import { UserControlService } from "../../air/modules/common/service/userControl/user-control.service";
// import { MessageService } from "primeng/api";
import { AirAppRoutes } from "../../air/modules/common/lib/air-api-constant";
import {
    IFiltersCriteria,
    ISelectedFilters,
} from "../../air/modules/common/lib/types/selectedFilters";
import { EFeatures } from "../../air/modules/common/lib/model/common";
// import { GraphBuilder } from "src/app/air/modules/common/Graphs/graphBuilder";
import { GraphBuilder } from "src/app/air/modules/common/Graphs/graphBuilder";
import { DirectLinkTopbarComponent } from "../direct-link-topbar/direct-link-topbar.component";
import { UtilityService } from "../../air/modules/common/service/utility/utility.service";

@Component({
    selector: "app-direct-link-shipment-tracking-details",
    templateUrl: "./direct-link-shipment-tracking-details.component.html",
    styleUrls: ["./direct-link-shipment-tracking-details.component.scss"],
    standalone: false
})
export class DirectLinkShipmentTrackingDetailsComponent {
    @ViewChild('tntMap') tntMap: ElementRef;
    private mapInitialized = false;
    mapMarkers: Array<any> = [];
    homeMap: GraphBuilder = null;
    graphId: string = "tntDetailedMap";
    private filterSelection: ISelectedFilters = null;
    tabDetails: any = {};
    stepsItems: any;
    assignments: any;
    bdpid!: string;
    shipmentId!: string;
    assignment: any;
    keyRef: any = {};
    coveredRouteList: any = [];
    pointSourceList: any = [];
    allRouteCoordinates: { lat: any; lng: any }[] = [];
    shipmentDetails: any = {};
    showPredictedRoute: boolean = true;
    pointId: any = null;
    uncoveredRouteList: [][] = [];
    completed: boolean = false;
    resizableMaxHeight: number = window.innerHeight - 100;
    resizableMinHeight: number = 250;
    display: boolean | undefined;
    private isMapDataLoaded = false;
    private maxRetries = 3;
    private retryDelay = 1000;
    shipmentInfo: any = {
        etaInfromation: {},
        generalInformation: {},
        currentLocation: {},
    };
    popup: mapboxgl.Popup;
    plcOfRecptPoint: {
        portId: string;
        latitude: number;
        longitude: number;
        symbol: string;
        portName: string;
        isActual: number;
    };
    plcOfDelvryPoint: {
        portId: string;
        latitude: number;
        longitude: number;
        symbol: string;
        portName: string;
        isActual: number;
    };
    polPoint: {
        portId: string;
        latitude: number;
        longitude: number;
        symbol: string;
        portName: string;
    };
    podPoint: {
        portId: string;
        latitude: number;
        longitude: number;
        symbol: string;
        portName: string;
    };
    trshpPoint: {
        portId: string;
        latitude: number;
        longitude: number;
        symbol: string;
        portName: string;
    }[];
    firstCoodinates: {
        latitude: number;
        longitude: number;
    };
    lastCoodinates: {
        latitude: number;
        longitude: number;
    };
    flightLocation: {
        carrierName: string;
        flightNumber: string;
        bdpReferenceNo: string;
        speedVertical: string;
        speedHorizontal: string;
        altitude: string;
        portId: string;
        latitude: number | null;
        longitude: number | null;
        status: string;
        nextPort: string;
        eta: string;
        symbol: string;
        positionText: string | null;
    };
    shipmentStatus!: number;
    selectedCompany: any;
    private subscription = new SubSink();
    public selectedGlobalFilter: ISelectedFilters;
    intersection: boolean | undefined;
    trackingListLink: any;
    hasLiveTrackingAccessForUser: boolean = false;
    hasLiveTracking: boolean = false;
    isValidUserCount: number = 0;
    contanierRefKey: string = "containerNumber";
    containerNumbers: any = [];
    isActiveShipment: boolean = false;
    isDocsOnly: boolean = false;
    timeZoneDifference: any;
    badgeStatus: any;
    badgeflightNumber: any;
    badgeShipmentType: any;
    key: any;
    currentMapHeight: number = 500;
    bdpReferenceNo: any;
    sortedStepsItems: any[];
    isLiveTrackPendingOnly: boolean=false;
//Author ---Kalindi Tripathi
    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private shipmentService: ShipmentService,
        private trackingService: TrackingService,
        private filterService: FilterService,
        private vesselSerive: VesselService,
        private authService: AuthService,
        private commonService: CommonService,
        private userControlService: UserControlService,
       // private messageService: MessageService,
        private utilityService: UtilityService,
        private storageService: StorageService
    ) {
        this.trshpPoint = [];
        //  this.shipmentId = this.activatedRoute.snapshot.paramMap.get("shipmentid");
        this.assignments = [];
        // Extract the key from the URL
       
        this.activatedRoute.fragment.subscribe(fragment => {
            const url = new URL(window.location.href);
            const pathSegments = url.hash.split('/');
            this.key = pathSegments[pathSegments.length - 1];

            this.subscription.add(
                this.trackingService.getDirectLinkAccess(this.key).subscribe({
                    next: (res: any) => {
                        // Check for failed status and message
                        if (res.message === 'failed') {
                            // this.messageService.add({
                            //     key: 'errorToaster',
                            //     severity: 'error',
                            //     summary: 'Error',
                            //     detail: res.data || 'Invalid E-Link URL!' // Use the message from data or fallback
                            // });
                            setTimeout(() => {
                                this.router.navigate([AirAppRoutes.DirectLink.LINK_NOT_FOUND]);
                            });
                            return;
                        }

                        if (res.data?.shipmentId) {
                            this.shipmentId = res.data.shipmentId;
                            this.isLiveTrackPendingOnly = false;
                            this.isActiveShipment=false;
                            // Use forkJoin to combine the API calls
                            forkJoin({
                                shipmentInfo: this.fetchShipmentInfo(this.shipmentId),
                                timelineDetails: this.getTimeLineDetails(this.shipmentId),
                                vesselRouteDetails: this.getFlightRouteDetails(this.shipmentId)
                            }).subscribe({
                                next: (results) => {
                                    // this.isLiveTrackPendingOnly = false;
                                    // this.isActiveShipment=false;
                                   // console.log('All API calls completed:', results);
                                    this.plotMap();
                                },
                                error: (error) => {
                                   // console.error('Error in forkJoin:', error);
                                    // this.messageService.add({
                                    //     key: 'errorToaster',
                                    //     severity: 'error',
                                    //     summary: 'Error',
                                    //     detail: 'An error occurred while fetching data'
                                    // });
                                }
                            });
                        } else {
                            // this.messageService.add({
                            //     key: 'errorToaster',
                            //     severity: 'error',
                            //     summary: 'Error',
                            //     detail: 'Link key has expired'
                            // });
                        }
                    },
                    error: (error: any) => {
                        console.error('Error:', error);
                        const errorMessage = error.error?.data || error.message || 'Link key has expired or is invalid';
                        // this.messageService.add({
                        //     key: 'errorToaster',
                        //     severity: 'error',
                        //     summary: 'Error',
                        //     detail: errorMessage
                        // });
                        // Navigate to not found page after showing error
                        setTimeout(() => {
                            this.router.navigate([AirAppRoutes.DirectLink.LINK_NOT_FOUND]);
                        });
                    }
                })
            );
        });

        this.isDocsOnly = false;
        this.assignment = {};
        this.stepsItems = [];
        this.trackingListLink = [
            this.commonService.getRoute({
                route: AirAppRoutes.User.TRACKING_LIST,
                type: "User",
            }),
        ];
        this.subscription.add(
            this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationEnd) {
                    if (
                        this.commonService.isTrackingListDetailsRoute(event.url)
                    ) {
                        this.trshpPoint = [];
                        //this.shipmentId = this.activatedRoute.snapshot.paramMap.get("shipmentid");
                        this.assignments = [];
                        this.assignment = {};
                        this.stepsItems = [];

                        let defaultFilters =
                            this.storageService.getItem("defaultFilters");
                        let filters = JSON.parse(
                            JSON.stringify(defaultFilters)
                        );
                        this.storageService.setItem("filters", filters);
                        this.filterService.updateFilterSelection(
                            filters,
                            "trackingList-Details"
                        );

                        // this.commonService.navigateRoute({ route: AirAppRoutes.User.HOME, type: 'User' });
                    }
                }
            }),
            this.shipmentService.$shipmentSearch.subscribe(
                (globalSearchValue: any) => {
                    if (globalSearchValue) {
                        const shipment =
                            globalSearchValue && globalSearchValue.length > 0
                                ? globalSearchValue[0]
                                : {};
                        if (
                            shipment.shipmentId &&
                            shipment.shipmentId?.toString() !=
                            this.shipmentDetails.shipmentId
                        ) {
                            this.shipmentId = shipment.shipmentId;
                            this.customNgAfterViewInit();
                            // this.ngAfterViewInit();
                        }
                    }
                }
            )
        );
        //  this.getTimeLineDetails(this.shipmentId);
    }

    customNgAfterViewInit() {
        this.homeMap = new GraphBuilder(4, {
            id: this.graphId,
            graphType: "tntMapbox",
            container: this.graphId,
            // color: "#f58331",
            titleFontSize: "18",
            toolTipUnit: "",
            yAxisDiscription: "",
        });

        this.loadMap(this.selectedGlobalFilter);
    }
  
    plotMap() {
        if (!this.homeMap || !this.homeMap.getChart()) {
            console.warn('Map not initialized');
            return;
        }

        // Clear existing data
        this.clearMap();

        // Add route data first
        if (this.coveredRouteList && this.coveredRouteList.length > 0) {
            const map = this.homeMap.getChart();

            map.addSource('route', {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'LineString',
                        coordinates: this.coveredRouteList
                    }
                }
            });

            map.addLayer({
                id: 'route',
                type: 'line',
                source: 'route',
                layout: {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                paint: {
                    'line-color': this.shipmentStatus === 3 ? '#828282' : '#2d74ff',
                    'line-width': 2
                }
            });
        }

        // Then add markers
        if (this.polPoint && this.podPoint) {
            this.addMarker(this.polPoint, "POL");
            this.addMarker(this.podPoint, "POD");
            this.addTrackingSeries();
        }
    }
    ngOnInit(): void {
     //   this.customNgAfterViewInit();
        this.isDocsOnly = false;
        this.isActiveShipment=false; 
        this.isLiveTrackPendingOnly = false;
        this.subscription.add(
            this.filterService.$keyRef.subscribe((keyRef) => {
                keyRef = JSON.parse(JSON.stringify(keyRef));
                //Reset the keyRef value on each time details page is loaded.
                keyRef.value = "";
                if (this.shipmentDetails.shipmentId) {
                    if (
                        this.shipmentDetails[keyRef.key] &&
                        this.shipmentDetails[keyRef.key].toLowerCase() != "n/a"
                    ) {
                        keyRef.value = this.shipmentDetails[keyRef.key];
                    } else if (
                        keyRef.key &&
                        keyRef.key == this.contanierRefKey
                    ) {
                        keyRef = {
                            key: "containerNumber",
                            label: "Container #(s)",
                            value: this.containerNumbers.join(", "),
                            shortLabel: "Container #(s)",
                            keyIndex: 6,
                        };
                    } else {
                        keyRef = {
                            key: "bdpReferenceNumber",
                            label: "Forwarder Ref No. ",
                            value: this.shipmentInfo.generalInformation
                                .bdpReferenceNo,
                            shortLabel: "Forwarder Ref No. ",
                            keyIndex: 1,
                        };
                    }
                }
                this.keyRef = keyRef;
            }),
            this.filterService.$filterSelection.subscribe((filter) => {
                if (filter) {
                    const filterSelected: IFiltersCriteria =
                        this.filterService.getIds(filter);
                    //   this.selectedGlobalFilter = JSON.parse(JSON.stringify(filterSelected));
                } else {
                    // const filterSelected: IFiltersCriteria = this.filterService.getIds(
                    //     this.filterSelection
                    // );
                    // this.selectedGlobalFilter = JSON.parse(JSON.stringify(filterSelected));
                }
            }),
            this.filterService.$companyChanged.subscribe((status) => {
                if (this.selectedCompany) {
                    if (this.selectedCompany != status) {
                        this.commonService.navigateRoute({
                            route: AirAppRoutes.User.HOME,
                            type: "User",
                        });
                    }
                }
                this.selectedCompany = status;
            }),
            // this.userControlService.$userFeatures.subscribe((features: any) => {
            //     for (let i = 0; i < features.length; i++) {
            //         if (features[i].name == EFeatures.LIVE_TRACKING) {
            //             this.hasLiveTrackingAccessForUser = true;
            //             this.hasLiveTracking = true;
            //             break;
            //         }
            //     }
            // })
        );
    }

    move(ev: any) { }

    setShipmentDetails(data: { containerDetails: any }) {
        this.shipmentDetails = data;
        this.containerNumbers = [];
        // if (
        //     !this.shipmentDetails.isReadyToServe ||
        //     this.shipmentDetails.carrierName == "UNKN"
        // ) {
        //     this.hasLiveTracking = false;
        // } else {
        //     this.hasLiveTracking = true;
        // }

        if (this.shipmentDetails.shipmentStatusCode == 5) {
            this.isActiveShipment = true;
        }
        if (this.shipmentDetails.shipmentStatusCode == 11) {
            this.isLiveTrackPendingOnly = true;
        }

        if (
            this.shipmentDetails[this.keyRef.key] &&
            this.shipmentDetails[this.keyRef.key].toLowerCase() != "n/a"
        ) {
            const temp = JSON.parse(JSON.stringify(this.keyRef));
            temp.value = this.shipmentDetails[this.keyRef.key];
            this.keyRef = temp;
            // US#5420 Updating value for key referenc Container Number(s)
        } else if (this.keyRef.key && this.keyRef.key == this.contanierRefKey) {
            this.setContainerKeyRefValue(data.containerDetails, this.keyRef);
        } else {
            this.keyRef = {
                key: "bdpReferenceNumber",
                label: "Forwarder Ref No",
                value: this.shipmentInfo.generalInformation.bdpReferenceNo,
                shortLabel: "Forwarder Ref No",
                keyIndex: 1,
            };
        }
        if (this.shipmentInfo) {
            this.addTrackingSeries();
        }
    }

    getTimeLineDetails(body: string): Observable<any> {
        return this.trackingService.getTimeLineDetails(body).pipe(
            tap((res) => {
                //  console.log('Timeline Response:', res);

                if (res?.data?.timeLineResponses?.length) {
                    const actual = ["REC", "DEP", "ARR", "ARR"];
                    const estimate = ["ETA", "ETA", "DEP", "ETA"];

                    this.timeZoneDifference = res.data.timeDifference || "";
                    if (this.timeZoneDifference?.startsWith("0 days")) {
                        this.timeZoneDifference = this.timeZoneDifference
                            .replace("0 days", "")
                            .trim();
                    }

                    this.stepsItems = res.data.timeLineResponses
                        .map((item: any) => {
                         //   console.log("Timeline Item:", item);
                            return {
                                ...item,
                                color:
                                    item.status === "On Time"
                                        ? "green"
                                        : item.status?.includes("Late")
                                            ? "orange"
                                            : "",
                                completed: item.completed || 0,
                                date: item.date || null,
                                isActual: actual.includes(item.eventCode),
                                isEstimate: estimate.includes(item.eventCode),
                            };
                        })
                        this.sortedStepsItems = [...this.stepsItems].reverse();
                        //.reverse(); // Add reverse() here
                    } else {
                        //   console.warn('No timeline data available');
                        this.stepsItems = [];
                        this.sortedStepsItems = [];
                    }
            }),)

    }
    //#endregion
    getFlightRouteDetails(shipmentId) {
        this.flightLocation = null;
        this.polPoint = null;
        this.podPoint = null;
        this.plcOfRecptPoint = null;
        this.plcOfDelvryPoint = null;
        this.trshpPoint = [];
        this.allRouteCoordinates = [];
        this.pointSourceList = [];
        this.coveredRouteList = [];
        this.uncoveredRouteList = [];
        return this.vesselSerive.getCoveredRoute(shipmentId).pipe(
            first(),
            tap((res: any) => {
                const response = res.data;
                this.flightLocation = {
                    carrierName: response?.flightLocation?.carrierName,
                    bdpReferenceNo: response?.flightLocation?.bdpRef,
                    flightNumber: response?.flightLocation?.flightNumber,
                    speedVertical: response?.flightLocation?.speedVertical,
                    speedHorizontal: response?.flightLocation?.speedHorizontal,
                    altitude: response?.flightLocation?.altitude,
                    portId: response?.flightLocation?.vesselId,
                    latitude: parseFloat(response?.flightLocation?.latitude),
                    longitude: parseFloat(response?.flightLocation?.longitude),
                    status: response?.flightLocation?.status,
                    nextPort: response?.flightLocation?.nextPort,
                    eta: response?.flightLocation?.eta,
                    symbol: "",
                    positionText: null
                };
                this.shipmentStatus = response.shipmentStatus;
                if (response.coveredRoute.length > 0) {
                    this.firstCoodinates = {
                        latitude: response.coveredRoute[0].latitude,
                        longitude: response.coveredRoute[0].longitude,
                    };
                    this.lastCoodinates = {
                        latitude:
                            response.coveredRoute[
                                response.coveredRoute.length - 1
                            ].latitude,
                        longitude:
                            response.coveredRoute[
                                response.coveredRoute.length - 1
                            ].longitude,
                    };
                } else {
                    this.firstCoodinates = {
                        latitude: parseFloat(
                            response.departureAirport?.latitude
                        ),
                        longitude: parseFloat(
                            response.departureAirport?.longitude
                        ),
                    };
                    this.lastCoodinates = {
                        latitude: parseFloat(
                            response.arrivalAirport?.latitude
                        ),
                        longitude: parseFloat(
                            response.arrivalAirport?.longitude
                        ),
                    };
                }

                if (response.placeOfReceipt) {
                    this.plcOfRecptPoint = {
                        latitude: response.placeOfReceipt?.portLat,
                        longitude: response.placeOfReceipt?.portLng,
                        portName: response.placeOfReceipt?.portName,
                        portId: response.placeOfReceipt?.portUnlocCode,
                        symbol: "url(./assets/layout/images/bdp-port-of-destination.svg)",
                        isActual: response.placeOfReceipt.isActual,
                    };
                }
                if (response.placeOfDelivery) {
                    this.plcOfDelvryPoint = {
                        latitude: response.placeOfDelivery?.portLat,
                        longitude: response.placeOfDelivery?.portLng,
                        portName: response.placeOfDelivery?.portName,
                        portId: response.placeOfDelivery?.portUnlocCode,
                        symbol: "url(./assets/layout/images/bdp-port-of-destination.svg)",
                        isActual: response.placeOfDelivery.isActual,
                    };
                }
                if (response.arrivalAirport) {
                    this.allRouteCoordinates.push({
                        lat: parseFloat(response.arrivalAirport?.latitude),
                        lng: parseFloat(response.arrivalAirport?.longitude),
                    });
                    this.polPoint = {
                        latitude: parseFloat(
                            response.arrivalAirport?.latitude
                        ),
                        longitude: parseFloat(
                            response.arrivalAirport?.longitude
                        ),
                        portName: response.arrivalAirport?.portName,
                        portId: response.arrivalAirport?.portId,
                        symbol:
                            response.shipmentStatus != 3
                                ? "url(./assets/layout/images/bdp-port-of-destination.svg)"
                                : "url(./assets/layout/images/bdp-port-of-destination-completed.svg)",
                    };
                }
                if (response.departureAirport) {
                    this.allRouteCoordinates.push({
                        lat: parseFloat(response.departureAirport?.latitude),
                        lng: parseFloat(
                            response.departureAirport?.longitude
                        ),
                    });
                    this.podPoint = {
                        latitude: parseFloat(
                            response.departureAirport?.latitude
                        ),
                        longitude: parseFloat(
                            response.departureAirport?.longitude
                        ),
                        portName: response.departureAirport?.portName,
                        portId: response.departureAirport?.portId,
                        symbol:
                            response.shipmentStatus != 3
                                ? "url(./assets/layout/images/bdp-port-of-loading.svg)"
                                : "url(./assets/layout/images/bdp-port-of-loading-completed.svg)",
                    };
                }
                if (response.transAirport) {
                    for (let count = 0; count < response.transAirport.length; count++) {
                        const lat = parseFloat(response.transAirport[count].latitude);
                        const lng = parseFloat(response.transAirport[count].longitude);
                        const portName = response.transAirport[count].portName;
                        const portId = response.transAirport[count].portId;
                        const symbol =
                            response.shipmentStatus !== 3
                                ? "./assets/layout/images/air-transhipment.svg"
                                : "./assets/layout/images/Air_Arrived_Transhipment.svg";
                
                        const trshp = {
                            latitude: lat,
                            longitude: lng,
                            portName: portName,
                            portId: portId,
                            symbol: `url(${symbol})` 
                        };
                
                        // Push to array
                        this.trshpPoint.push(trshp);
                
                        // Immediately add marker
                        this.addMarker({
                            latitude: lat,
                            longitude: lng,
                            portName: portName,
                            portId: portId,
                            symbol: symbol // Pass raw URL here if used in Leaflet icon
                        }, "TRANSSHIPMENT");
                    }
                }
                
                if (response.flightLocation &&  response.shipmentStatus != 3) {
                    this.allRouteCoordinates.push({
                        lat: parseFloat(response.flightLocation.latitude),
                        lng: parseFloat(response.flightLocation.longitude),
                    });
                    let symbolUrl = "";
                    if (response.flightLocation.status == "On Time") {
                        symbolUrl =
                            "url(./assets/layout/images/bdp-air-ontime-shipment.svg)";
                    } else if (response.flightLocation.status == "Early") {
                        symbolUrl =
                            "url(./assets/layout/images/bdp-air-early-shipment.svg)";
                    } else if (response.flightLocation.status == "Late") {
                        symbolUrl =
                            "url(./assets/layout/images/bdp-air-late-shipment.svg)";
                    } else if (
                        response.flightLocation.navigationalStatusCode ==
                        0 ||
                        response.flightLocation.navigationalStatusCode == 1
                    ) {
                        symbolUrl =
                            "url(./assets/layout/images/anchorage_terminal.svg)";
                    } else {
                        symbolUrl =
                            "url(./assets/layout/images/bdp-air-ontime-shipment.svg)";
                    }
                    if (
                        response.shipmentStatus == 3 &&
                        this.polPoint.latitude !=
                        this.lastCoodinates.latitude &&
                        this.polPoint.longitude !=
                        this.lastCoodinates.longitude
                    ) {
                        this.flightLocation = {
                            flightNumber: response.flightLocation.flightNumber,
                            bdpReferenceNo: response.flightLocation.bdpRef,
                            speedVertical: response.flightLocation.speedVertical,
                            speedHorizontal: response.flightLocation.speedHorizontal,
                            altitude: response.flightLocation.altitude,
                            carrierName: response.flightLocation.carrierName,
                            latitude: this.polPoint.latitude,
                            longitude: this.polPoint.longitude,
                            nextPort: response.flightLocation.nextPort,
                            eta: response.flightLocation.eta,
                            symbol: symbolUrl,
                            portId: response.flightLocation.vesselId,
                            status: response.flightLocation.status,
                            positionText: null,
                        };
                    } else {
                        this.flightLocation = {
                            latitude: parseFloat(
                                response.flightLocation.latitude
                            ),
                            longitude: parseFloat(
                                response.flightLocation.longitude
                            ),
                            flightNumber: response.flightLocation.flightNumber,
                            bdpReferenceNo: response.flightLocation.bdpRef,
                            speedVertical: response.flightLocation.speedVertical,
                            speedHorizontal: response.flightLocation.speedHorizontal,
                            altitude: response.flightLocation.altitude,
                            carrierName: response.flightLocation.carrierName,
                            nextPort: response.flightLocation.nextPort,
                            eta: response.flightLocation.eta,
                            symbol: symbolUrl,
                            portId: response.flightLocation.vesselId,
                            status: response.flightLocation.status,
                            positionText: null,
                        };
                    }
                    // if (
                    //     response.flightLocation.navigationalStatusCode ==
                    //     0 ||
                    //     response.flightLocation.navigationalStatusCode == 1
                    // ) {
                    //     this.flightLocation.positionText =
                    //         response.flightLocation.vesselPositionText;
                    // }
                }
                // if (
                //     response.coveredRoute.length === 0 &&
                //     response.shipmentStatus === 3
                // ) {
                //     // Add departure airport (POL)
                //     this.coveredRouteList.push([
                //         parseFloat(response.departureAirport.longitude),
                //         parseFloat(response.departureAirport.latitude),
                //     ]);
                //     this.addMarker(this.polPoint, "POL");

                //     // Add transhipment points (if any)
                //     if (response.transAirport && response.transAirport.length > 0) {
                //         for (let i = 0; i < response.transAirport.length; i++) {
                //             const lat = parseFloat(response.transAirport[i].latitude);
                //             const lng = parseFloat(response.transAirport[i].longitude);

                //             // Push into route for line drawing
                //             this.coveredRouteList.push([lng, lat]);

                //             // Add marker
                //             this.trshpPoint.push({
                //                 latitude: lat,
                //                 longitude: lng,
                //                 portName: response.transAirport[i].portName,
                //                 portId: response.transAirport[i].portId,
                //                 symbol: "url(./assets/layout/images/Air_Arrived_Transhipment.svg)", // or dynamic based on status
                //             });
                //         }

                //         // Add all transhipment markers
                //         for (let count = 0; count < this.trshpPoint.length; count++) {
                //             this.addMarker({
                //                 index: count,
                //                 portId: this.trshpPoint[count].portId,
                //                 latitude: this.trshpPoint[count].latitude,
                //                 longitude: this.trshpPoint[count].longitude,
                //                 portName: this.trshpPoint[count].portName,
                //                 symbol: this.trshpPoint[count].symbol,
                //             }, "TRANSSHIPMENT");
                //         }
                //     }

                //     // Add arrival airport (POD)
                //     this.coveredRouteList.push([
                //         parseFloat(response.arrivalAirport.longitude),
                //         parseFloat(response.arrivalAirport.latitude),
                //     ]);
                //     this.addMarker(this.podPoint, "POD");

                //     // Finally draw the complete line
                //     //  this.addLine(this.coveredRouteList);
                // }

                if (response?.coveredRoute?.length) {
                    let differentSide;
                    let differentSideCount = [];
                    let rightIntersection = [];
                    const tPointSourceList: any = [];
                       this.firstCoodinates = { 
                                                      latitude: response.coveredRoute[0].latitude, 
                                                      longitude: response.coveredRoute[0].longitude 
                                                  };
                                                  this.lastCoodinates = { 
                                                      latitude: response.coveredRoute[response.coveredRoute.length - 1].latitude, 
                                                      longitude: response.coveredRoute[response.coveredRoute.length - 1].longitude 
                                                  };
                                              
                                                  // Process points in original sequence
                                                  for (let count = 0; count < response.coveredRoute.length - 1; count++) {
                                                      this.allRouteCoordinates.push({ 
                                                          lat: response.coveredRoute[count].latitude, 
                                                          lng: response.coveredRoute[count].longitude 
                                                      });
                                                      
                                                      differentSide = this.checkInterSection(
                                                          response.coveredRoute[count].longitude, 
                                                          response.coveredRoute[count + 1].longitude
                                                      );
                                                      
                                                      if (differentSide) {
                                                          if (response.coveredRoute[count].longitude > response.coveredRoute[count + 1].longitude) {
                                                              rightIntersection.push(true);
                                                          } else {
                                                              rightIntersection.push(false);
                                                          }
                                                          differentSideCount.push(count);
                                                      }
                                                  }
                                              
                                                  // Add points to covered route list in original sequence
                                                  for (let count = 0; count < response.coveredRoute.length; count++) {
                                                      if (this.intersection) {
                                                          if (count > differentSideCount[0]) {
                                                              if (differentSideCount.length > 1 && count <= differentSideCount[1]) {
                                                                  response.coveredRoute[count].longitude = this.getlatLongCorrection(
                                                                      response.coveredRoute[count].longitude, 
                                                                      rightIntersection[0]
                                                                  );
                                                              } 
                                                              if (differentSideCount.length == 1) {
                                                                  response.coveredRoute[count].longitude = this.getlatLongCorrection(
                                                                      response.coveredRoute[count].longitude, 
                                                                      rightIntersection[0]
                                                                  );
                                                              }
                                                          }
                                                      }
                                                      
                                                      let latLong: any = new mapboxgl.LngLat(
                                                          response.coveredRoute[count].longitude, 
                                                          response.coveredRoute[count].latitude
                                                      );
                                                      
                                                      this.coveredRouteList.push(latLong.toArray());
                                                      
                                                      tPointSourceList.push({
                                                          'properties': {
                                                              date: moment(new Date(response.coveredRoute[count].updated))
                                                                  .format('DD-MM-YYYY HH:mm'),
                                                              latLong: latLong.toArray()
                                                          },
                                                          id: this.utilityService.getRandomNo(),
                                                          'geometry': {
                                                              'type': 'Point',
                                                              'coordinates': latLong.toArray()
                                                          }
                                                      });
                                                  }
                    // for (
                    //     let count = 0;
                    //     count < response.coveredRoute.length - 1;
                    //     count++
                    // ) {
                    //     this.allRouteCoordinates.push({
                    //         lat: parseFloat(
                    //             response.coveredRoute[count].latitude
                    //         ),
                    //         lng: parseFloat(
                    //             response.coveredRoute[count].longitude
                    //         ),
                    //     });
                    //     differentSide = this.checkInterSection(
                    //         response.coveredRoute[count].longitude,
                    //         response.coveredRoute[count + 1].longitude
                    //     );
                    // }
                    // for (
                    //     let count = 0;
                    //     count < response.coveredRoute.length;
                    //     count++
                    // ) {
                    //     tPointSourceList.push({
                    //         type: "Feature",
                    //         geometry: {
                    //             type: "Point",
                    //             coordinates: [
                    //                 parseFloat(
                    //                     response.coveredRoute[count]
                    //                         .longitude
                    //                 ),
                    //                 parseFloat(
                    //                     response.coveredRoute[count]
                    //                         .latitude
                    //                 ),
                    //             ],
                    //         },
                    //         properties: {
                    //             date: response.coveredRoute[count].date,
                    //         },
                    //     });
                    //     this.coveredRouteList.push([
                    //         parseFloat(
                    //             response.coveredRoute[count].longitude
                    //         ),
                    //         parseFloat(
                    //             response.coveredRoute[count].latitude
                    //         ),
                    //     ]);
                    // }
                    this.pointSourceList = tPointSourceList;
                }
                const hasOnlyAirportData =
                    response.departureAirport &&
                    response.arrivalAirport &&
                    (response.shipmentStatus === 2) &&
                    (!response.coveredRoute ||
                        response.coveredRoute.length === 0);

                if (hasOnlyAirportData) {
                    // Add origin airport marker
                    if (response.departureAirport) {
                        this.podPoint = {
                            latitude: parseFloat(
                                response.departureAirport.latitude
                            ),
                            longitude: parseFloat(
                                response.departureAirport.longitude
                            ),
                            portName: response.departureAirport.portName,
                            portId: response.departureAirport.portId,
                            symbol: "url(./assets/layout/images/bdp-port-of-loading.svg)",
                        };
                        this.addMarker(this.podPoint, "POD");
                    }

                    // Add destination airport marker
                    if (response.arrivalAirport) {
                        this.polPoint = {
                            latitude: parseFloat(
                                response.arrivalAirport.latitude
                            ),
                            longitude: parseFloat(
                                response.arrivalAirport.longitude
                            ),
                            portName: response.arrivalAirport.portName,
                            portId: response.arrivalAirport.portId,
                            symbol: "url(./assets/layout/images/bdp-port-of-destination.svg)",
                        };
                        this.addMarker(this.polPoint, "POL");
                    }
                    //trshp
                    if (this.trshpPoint) {
                        for (
                            let count = 0;
                            count < this.trshpPoint.length;
                            count++
                        ) {
                            this.addMarker(
                                {
                                    index: count,
                                    portId: this.trshpPoint[count].portId,
                                    latitude: this.trshpPoint[count].latitude,
                                    longitude: this.trshpPoint[count].longitude,
                                    portName: this.trshpPoint[count].portName,
                                    // count: 92,
                                    symbol: this.trshpPoint[count].symbol,
                                },
                                "TRANSSHIPMENT"
                            );
                        }
                    }
                    // Set coordinates for map boundaries
                    this.firstCoodinates = {
                        latitude: parseFloat(
                            response.departureAirport?.latitude
                        ),
                        longitude: parseFloat(
                            response.departureAirport?.longitude
                        ),
                    };
                    this.lastCoodinates = {
                        latitude: parseFloat(
                            response.arrivalAirport.latitude
                        ),
                        longitude: parseFloat(
                            response.arrivalAirport.longitude
                        ),
                    };
                    if (this.shipmentStatus == 1) {
                        if (this.polPoint) {
                            this.addMarker(
                                {
                                    portId: this.polPoint?.portId,
                                    latitude: this.polPoint?.latitude,
                                    longitude: this.polPoint?.longitude,
                                    portName: this.polPoint?.portName,
                                    symbol: this.polPoint?.symbol,
                                },
                                "POL"
                            );
                        }
                        if (this.podPoint) {
                            this.addMarker(
                                {
                                    portId: this.podPoint?.portId,
                                    latitude: this.podPoint?.latitude,
                                    longitude: this.podPoint?.longitude,
                                    portName: this.podPoint?.portName,
                                    symbol: this.podPoint?.symbol,
                                },
                                "POD"
                            );
                        }
                        //trshp
                        if (response.transAirport) {
                            for (let count = 0; count < response.transAirport.length; count++) {
                                const lat = parseFloat(response.transAirport[count].latitude);
                                const lng = parseFloat(response.transAirport[count].longitude);
                                const portName = response.transAirport[count].portName;
                                const portId = response.transAirport[count].portId;
                                const symbol =
                                    response.shipmentStatus !== 3
                                        ? "./assets/layout/images/air-transhipment.svg"
                                        : "./assets/layout/images/Air_Arrived_Transhipment.svg";
    
                                const trshp = {
                                    latitude: lat,
                                    longitude: lng,
                                    portName: portName,
                                    portId: portId,
                                    symbol: `url(${symbol})` // if you use it in CSS, keep `url(...)`
                                };
    
                                // Push to array
                                this.trshpPoint.push(trshp);
    
                                // Immediately add marker
                                this.addMarker({
                                    latitude: lat,
                                    longitude: lng,
                                    portName: portName,
                                    portId: portId,
                                    symbol: symbol // Pass raw URL here if used in Leaflet icon
                                }, "TRANSSHIPMENT");
                            }
                        }
    
                    }
                    setTimeout(() => {
                        this.addTrackingSeries();
                    }, 2000);
                }
             
                this.fitToBox();
            })
        );
    }

    ngAfterViewInit() {
        this.customNgAfterViewInit();
        if (!this.isDocsOnly) {
      //      console.log("Map element:", this.tntMap); // Debug log
            this.initializeMap();
        }
    }
    private initializeMap() {
        if (this.tntMap?.nativeElement && !this.mapInitialized) {
            try {
                this.homeMap = new GraphBuilder(4, {
                    id: this.graphId,
                    graphType: "tntMapbox",
                    container: this.graphId,
                    titleFontSize: "18",
                    toolTipUnit: "",
                    yAxisDiscription: "",
                });
                
                this.mapInitialized = true;
                this.loadMap(this.selectedGlobalFilter);
            } catch (error) {
                console.error('Error initializing map:', error);
            }
        }
    }
    //#region Load Map Data
    async addTrackingSeries() {
   //     console.log("Add tracking series");
        //  this.clearMap();
        try {
            // Wait for map data
            await this.waitForMapData();

            const map = this.homeMap.getChart();
            if (!map) {
                throw new Error("Map not initialized");
            }

            const routeColor =
                this.shipmentStatus === 3 ? "#828282" : "#2d74ff";
            map.getCanvas().style.cursor = "pointer";

            // Check if required data is available
            if (!this.uncoveredRouteList || !this.coveredRouteList) {
                throw new Error("Route data not available");
            }
            //  const map = this.homeMap.getChart();
            //const routeColor = this.shipmentStatus === 3 ? '#828282' : '#2d74ff';
            map.getCanvas().style.cursor = "pointer";
            map.on("styledata", () => {
                map.addSource("uncoveredRoute", {
                    type: "geojson",
                    data: {
                        type: "Feature",
                        properties: {},
                        geometry: {
                            type: "LineString",
                            coordinates: this.uncoveredRouteList,
                        },
                    },
                });

                map.addSource("coveredRoute", {
                    type: "geojson",
                    data: {
                        type: "Feature",
                        geometry: {
                            type: "LineString",
                            coordinates: this.coveredRouteList,
                        },
                    },
                });
                if (
                    this.plcOfRecptPoint &&
                    this.polPoint.portId !== this.plcOfRecptPoint.portId
                ) {
                    map.addSource("placeOfReceiptRoute", {
                        type: "geojson",
                        data: {
                            type: "Feature",
                            geometry: {
                                type: "LineString",
                                coordinates: [
                                    [
                                        this.polPoint.longitude,
                                        this.polPoint.latitude,
                                    ],
                                    [
                                        this.plcOfRecptPoint.longitude,
                                        this.plcOfRecptPoint.latitude,
                                    ],
                                ],
                            },
                        },
                    });
                    map.addLayer({
                        id: "placeOfReceiptRoute",
                        type: "line",
                        source: "placeOfReceiptRoute",
                        layout: {
                            "line-join": "round",
                            "line-cap": "round",
                        },
                        paint:
                            this.plcOfRecptPoint.isActual == 0
                                ? {
                                    "line-color": "#2d74ff",
                                    "line-width": 2,
                                    "line-dasharray": [2, 4],
                                }
                                : {
                                    "line-color": "#2d74ff",
                                    "line-width": 2,
                                },
                    });
                }

                if (
                    this.plcOfDelvryPoint &&
                    this.podPoint.portId !== this.plcOfDelvryPoint.portId
                ) {
                    map.addSource("placeOfDeliveryRoute", {
                        type: "geojson",
                        data: {
                            type: "Feature",
                            geometry: {
                                type: "LineString",
                                coordinates: [
                                    [
                                        this.podPoint.longitude,
                                        this.podPoint.latitude,
                                    ],
                                    [
                                        this.plcOfDelvryPoint.longitude,
                                        this.plcOfDelvryPoint.latitude,
                                    ],
                                ],
                            },
                        },
                    });
                    map.addLayer({
                        id: "placeOfDeliveryRoute",
                        type: "line",
                        source: "placeOfDeliveryRoute",
                        layout: {
                            "line-join": "round",
                            "line-cap": "round",
                        },
                        paint:
                            this.plcOfDelvryPoint.isActual == 0
                                ? {
                                    "line-color": "#2d74ff",
                                    "line-width": 2,
                                    "line-dasharray": [2, 4],
                                }
                                : {
                                    "line-color": "#2d74ff",
                                    "line-width": 2,
                                },
                    });
                }
                // Add origin and destination markers if shipment status is 1
                // Add origin and destination markers if shipment status is 1
                if (this.shipmentStatus == 1) {
                    if (this.polPoint) {
                        this.addMarker(
                            {
                                portId: this.polPoint?.portId,
                                latitude: this.polPoint?.latitude,
                                longitude: this.polPoint?.longitude,
                                portName: this.polPoint?.portName,
                                symbol: this.polPoint?.symbol,
                            },
                            "POL"
                        );
                    }
                    if (this.podPoint) {
                        this.addMarker(
                            {
                                portId: this.podPoint?.portId,
                                latitude: this.podPoint?.latitude,
                                longitude: this.podPoint?.longitude,
                                portName: this.podPoint?.portName,
                                symbol: this.podPoint?.symbol,
                            },
                            "POD"
                        );
                    }
                    //trshp
                    if (this.trshpPoint) {
                        for (
                            let count = 0;
                            count < this.trshpPoint.length;
                            count++
                        ) {
                            this.addMarker(
                                {
                                    index: count,
                                    portId: this.trshpPoint[count].portId,
                                    latitude: this.trshpPoint[count].latitude,
                                    longitude: this.trshpPoint[count].longitude,
                                    portName: this.trshpPoint[count].portName,
                                    // count: 92,
                                    symbol: this.trshpPoint[count].symbol,
                                },
                                "TRANSSHIPMENT"
                            );
                        }
                    }
                }

                // next if cluase is for showing a stright line between origin port and first lat long we are getting from response
                if (
                    this.firstCoodinates &&
                    this.podPoint.latitude !== this.firstCoodinates.latitude &&
                    this.podPoint.longitude !== this.firstCoodinates.longitude
                ) {
                    map.addSource("placeOfReceiptRoute", {
                        type: "geojson",
                        data: {
                            type: "Feature",
                            geometry: {
                                type: "LineString",
                                coordinates: [
                                    [
                                        this.podPoint.longitude,
                                        this.podPoint.latitude,
                                    ],
                                    [
                                        this.firstCoodinates.longitude,
                                        this.firstCoodinates.latitude,
                                    ],
                                ],
                            },
                        },
                    });
                    map.addLayer({
                        id: "placeOfReceiptRoute",
                        type: "line",
                        source: "placeOfReceiptRoute",
                        layout: {
                            "line-join": "round",
                            "line-cap": "round",
                        },
                        paint: {
                            "line-color": routeColor,
                            "line-width": 2,
                        },
                    });
                }

                map.addSource("pointSource", {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: this.pointSourceList,
                    },
                });

                map.addLayer({
                    id: "coveredRouteCircle",
                    class: "circle",
                    type: "circle",
                    source: "pointSource",
                    //source: 'coveredRoute',
                    paint: {
                        "circle-color":
                            this.shipmentStatus == 3 ? "#828282" : "#2d74ff",
                        "circle-radius": 3,
                        "circle-stroke-color": "#fff",
                        "circle-stroke-width": 1,
                        "circle-stroke-opacity": 0,
                    },
                    // paint: {
                    //     'circle-color': ['case', ['boolean', ['feature-state', 'hover'], false],
                    //         this.shipmentStatus == 3 ? '#2d74ff' : '#828282',
                    //         this.shipmentStatus == 3 ? '#828282' : '#2d74ff',
                    //     ],
                    //     // 'circle-stroke-color': '#fff',
                    //     // 'circle-stroke-width': 3,
                    //     'circle-radius': ['case', ['boolean', ['feature-state', 'hover'], false], 5, 3],
                    // },
                });

                map.addLayer({
                    id: "uncoveredRoute",
                    type: "line",
                    source: "uncoveredRoute",
                    // 'layout': {
                    //     'line-join': 'round',
                    //     'line-cap': 'round'
                    // },
                    paint: {
                        "line-color": "#2d74ff",
                        "line-width": 2,
                        "line-dasharray": [2, 4],
                    },
                });

                map.addLayer({
                    id: "coveredRoute",
                    type: "line",
                    source: "coveredRoute",
                    layout: {
                        "line-join": "round",
                        "line-cap": "round",
                    },
                    paint: {
                        "line-color":
                            this.shipmentStatus == 3 ? "#828282" : "#2d74ff",
                        "line-width": 2,
                    },
                });

                if (
                    this.flightLocation != null &&
                    this.flightLocation != undefined &&
                    !Number.isNaN(this.flightLocation?.latitude) &&
                    !Number.isNaN(this.flightLocation?.longitude)
                ) {
                    this.addMarker(
                        {
                            portId: this.flightLocation?.portId,
                            latitude: this.flightLocation?.latitude,
                            longitude: this.flightLocation?.longitude,
                            //count: 120,
                            // symbol: "url(./assets/layout/images/bdp-air-ontime-shipment.svg)",
                            symbol: this.flightLocation?.symbol,
                        },
                        "VESSEL"
                    );
                    // console.log(this.flightLocation.symbol)
                }
                //pol
                if (this.polPoint) {
                    this.addMarker(
                        {
                            portId: this.polPoint?.portId,
                            latitude: this.polPoint?.latitude,
                            longitude: this.polPoint?.longitude,
                            portName: this.polPoint?.portName,
                            // count: 120,
                            symbol: this.polPoint.symbol,
                        },
                        "POL"
                    );
                }
                //pod
                if (this.podPoint) {
                    this.addMarker(
                        {
                            portId: this.podPoint?.portId,
                            latitude: this.podPoint?.latitude,
                            longitude: this.podPoint?.longitude,
                            portName: this.podPoint?.portName,
                            // count: 92,
                            symbol: this.podPoint.symbol,
                        },
                        "POD"
                    );
                }
                //trshp
                if (this.trshpPoint) {
                    for (
                        let count = 0;
                        count < this.trshpPoint.length;
                        count++
                    ) {
                        this.addMarker(
                            {
                                index: count,
                                portId: this.trshpPoint[count].portId,
                                latitude: this.trshpPoint[count].latitude,
                                longitude: this.trshpPoint[count].longitude,
                                portName: this.trshpPoint[count].portName,
                                // count: 92,
                                symbol: this.trshpPoint[count].symbol,
                            },
                            "TRANSSHIPMENT"
                        );
                    }
                }
                //place of receipt
                if (this.plcOfRecptPoint) {
                    this.addMarker(
                        {
                            portId: this.plcOfRecptPoint?.portId,
                            latitude: this.plcOfRecptPoint?.latitude,
                            longitude: this.plcOfRecptPoint?.longitude,
                            portName: this.plcOfRecptPoint?.portName,
                            // count: 92,
                            symbol: this.plcOfRecptPoint.symbol,
                        },
                        "PLACEOFRECEIPT"
                    );
                }
                //place of delivery
                if (this.plcOfDelvryPoint) {
                    this.addMarker(
                        {
                            portId: this.plcOfDelvryPoint?.portId,
                            latitude: this.plcOfDelvryPoint?.latitude,
                            longitude: this.plcOfDelvryPoint?.longitude,
                            portName: this.plcOfDelvryPoint?.portName,
                            // count: 92,
                            symbol: this.plcOfDelvryPoint.symbol,
                        },
                        "PLACEOFDELIVERY"
                    );
                }

                this.popup = new mapboxgl.Popup({
                    closeButton: false,
                    closeOnClick: false,
                });

                map.on("mouseenter", "coveredRouteCircle", (e: any) => {
                    map.getCanvas().style.cursor = "pointer";
                    this.showPopup(e);
                });

                map.on("mouseleave", "coveredRouteCircle", () => {
                    map.getCanvas().style.cursor = "";
                    this.popup.remove();
                    this.pointId = null;
                });
                map.on("mousemove", "coveredRouteCircle", (e: any) => {
                    if (e.features.length > 0) {
                        if (this.pointId) {
                            map.setFeatureState(
                                {
                                    source: "pointSource",
                                    id: this.pointId,
                                },
                                {
                                    hover: false,
                                }
                            );
                        }
                        this.pointId = e.features[0].id;
                        map.setFeatureState(
                            {
                                source: "pointSource",
                                id: this.pointId,
                            },
                            {
                                hover: true,
                            }
                        );
                        this.showPopup(e);
                    }
                });
                this.fitToBox();
            });
            setTimeout(() => {
                this.fitToBox();
            }, 100);
        } catch (error) {
            console.error("Map initialization failed:", error);
        }
    }

    private async waitForMapData(retryCount = 0): Promise<void> {
        if (this.isMapDataLoaded) return;

        if (retryCount >= this.maxRetries) {
            throw new Error("Map data loading timeout");
        }

        if (!this.uncoveredRouteList || !this.coveredRouteList) {
            await new Promise((resolve) =>
                setTimeout(resolve, this.retryDelay)
            );
            return this.waitForMapData(retryCount + 1);
        }

        this.isMapDataLoaded = true;
    }
    private showPopup(e: any) {
        const coordinates = e.features[0].geometry.coordinates.slice();
        const date = moment(e.features[0].properties.updated).format(
            "DD-MM-YYYY HH:mm"
        );
        const description = `<b>Location: </b>${coordinates[0].toFixed(
            6
        )}/${coordinates[1].toFixed(6)}<br/><b>Date: </b>${date}`;
        this.popup
            .setLngLat(coordinates)
            .setHTML(description)
            .addTo(this.homeMap.getChart());
    }
    private fitToBox() {
        if (this.intersection) {
            let latArray = [];
            let lngArray = [];
            this.allRouteCoordinates.map(coordiante => {
                latArray.push(coordiante.lat);
                lngArray.push(coordiante.lng);
            })
            latArray.sort((a, b) => { return a - b });
            lngArray.sort((a, b) => { return a - b });

            const temp = {
                maxLat: latArray[latArray.length - 1],
                maxLng: lngArray[lngArray.length - 1],
                minLat: latArray[0],
                minLng: lngArray[0],
            }
            let rightIntersection
            let intersectionPoint
            for (let count = 0; count < lngArray.length - 1; count++) {
                if (lngArray[count] > 0 && lngArray[count + 1] < 0) {
                    temp.minLng = lngArray[count + 1]
                    rightIntersection = false;
                    intersectionPoint = count;
                }
                if (lngArray[count] < 0 && lngArray[count + 1] > 0) {
                    temp.minLng = lngArray[count]
                    rightIntersection = true;
                    intersectionPoint = count;
                }
            }
            if (rightIntersection) {
                for (let count = 0; count < lngArray.length; count++) {
                    if (count > intersectionPoint) {
                        lngArray[count] -= 360;
                    }
                }
                lngArray.sort((a, b) => { return a - b });
                temp.maxLng = lngArray[0];
                temp.minLng = lngArray[lngArray.length - 1];
            }
            else {
                if (temp.minLng < 0) {
                    temp.minLng += 360;
                }
            }
            const box = [
                [temp.maxLng, temp.maxLat],
                [temp.minLng, temp.minLat],
            ];
            const map = this.homeMap.getChart();
            map.fitBounds(box, { padding: { top: 50, bottom: 50, left: 50, right: 450 }, maxZoom: 10 });
        }
        else {
            const map = this.homeMap.getChart();
            const temp = {
                maxLat: 0,
                maxLng: 0,
                minLat: 90,
                minLng: 180,
            }
            this.coveredRouteList.map((cordinats: any) => {
                if (cordinats[0] > temp.maxLng) {
                    temp.maxLng = cordinats[0];
                }
                if (cordinats[1] > temp.maxLat) {
                    temp.maxLat = cordinats[1];
                }
                if (cordinats[0] < temp.minLng) {
                    temp.minLng = cordinats[0];
                }
                if (cordinats[1] < temp.minLat) {
                    temp.minLat = cordinats[1];
                }
            });
            this.uncoveredRouteList.map((cordinats: any) => {
                if (cordinats[0] > temp.maxLng) {
                    temp.maxLng = cordinats[0];
                }
                if (cordinats[1] > temp.maxLat) {
                    temp.maxLat = cordinats[1];
                }
                if (cordinats[0] < temp.minLng) {
                    temp.minLng = cordinats[0];
                }
                if (cordinats[1] < temp.minLat) {
                    temp.minLat = cordinats[1];
                }
            });
            if (this.podPoint) {
                if (this.podPoint.latitude > temp.maxLat) {
                    temp.maxLat = this.podPoint.latitude;
                }
                if (this.podPoint.latitude < temp.minLat) {
                    temp.minLat = this.podPoint.latitude;
                }
                if (this.podPoint.longitude > temp.maxLng) {
                    temp.maxLng = this.podPoint.longitude;
                }
                if (this.podPoint.longitude < temp.minLng) {
                    temp.minLng = this.podPoint.longitude;
                }
            }

            if (this.polPoint) {
                if (this.polPoint.latitude > temp.maxLat) {
                    temp.maxLat = this.polPoint.latitude;
                }
                if (this.polPoint.latitude < temp.minLat) {
                    temp.minLat = this.polPoint.latitude;
                }
                if (this.polPoint.longitude > temp.maxLng) {
                    temp.maxLng = this.polPoint.longitude;
                }
                if (this.polPoint.longitude < temp.minLng) {
                    temp.minLng = this.polPoint.longitude;
                }
            }
            const box = [
                [temp.maxLng, temp.maxLat],
                [temp.minLng, temp.minLat],
            ];
            (box);
            map.fitBounds(box, { padding: { top: 50, bottom: 50, left: 50, right: 450 }, maxZoom: 10 });
        }
    }

    resizeMap() {
        // Get wrapper height
        const wrapperEl = document.getElementById("bdpDraggableWrapper");
        if (!wrapperEl) return;

        const height = wrapperEl.offsetHeight;
        const adjustedHeight = height - 24; // Account for padding/margins

        // Update map height
        if (this.homeMap) {
            const map = this.homeMap.getChart();
            const mapDiv = document.getElementById(this.graphId);
            if (mapDiv) {
                mapDiv.style.height = `${adjustedHeight}px`;
                map.resize();
            }
        }

        // Update timeline container height to match map
        const timelineContainer = document.querySelector('.timeline-container') as HTMLElement;
        if (timelineContainer) {
            timelineContainer.style.height = `${adjustedHeight}px`;
            timelineContainer.style.overflowY = 'auto';
        }

        // Store current height for other components that might need it
        this.currentMapHeight = adjustedHeight;

        // Force change detection
        //  this.changeDetectorRef.detectChanges();
    }

 private addMarker(marker: any, iconType: string) {
    // Validate coordinates first
    if (!this.isValidCoordinates(marker?.longitude, marker?.latitude)) {
        console.warn(`Invalid coordinates for ${iconType} marker:`, marker);
        return;
    }

    const map = this.homeMap.getChart();
    if (!map) return;

    try {
        const el = document.createElement("div");
        el.className = "bdp-marker";
        el.style.backgroundImage = marker.symbol;
        el.style.width = "22px";
        el.style.height = "22px";
        el.style.backgroundSize = "100%";

        // Create marker with validated coordinates
        const coordinates: [number, number] = [
            parseFloat(marker.longitude),
            parseFloat(marker.latitude)
        ];

        const markerElem = new mapboxgl.Marker(el)
            .setLngLat(coordinates);

        // Add popup if needed
        if (iconType) {
            const popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false
            });

            let description = this.getMarkerDescription(marker, iconType);

            el.addEventListener('mouseenter', () => {
                this.removeAllMarker();
                popup.setLngLat(coordinates)
                    .setHTML(description)
                    .addTo(map);
            });

            el.addEventListener('mouseleave', () => {
                popup.remove();
            });
        }

        markerElem.addTo(map);
        this.mapMarkers.push(markerElem);

    } catch (error) {
        console.error(`Error adding ${iconType} marker:`, error);
    }
}

// Add these helper methods
private isValidCoordinates(lng: any, lat: any): boolean {
    const longitude = parseFloat(lng);
    const latitude = parseFloat(lat);
    
    return !isNaN(longitude) && 
           !isNaN(latitude) && 
           longitude >= -180 && 
           longitude <= 180 && 
           latitude >= -90 && 
           latitude <= 90;
}

private getMarkerDescription(marker: any, iconType: string): string {
    let description = `<b>Location:</b> ${marker.longitude}/${marker.latitude}<br/>`;

    switch (iconType) {
        case "VESSEL":
            if (this.flightLocation) {
                description = `
                    <b>Carrier:</b> ${this.flightLocation.carrierName || '-'}<br/>
                    <b>Forwarder Ref No.:</b> ${this.flightLocation.bdpReferenceNo}<br/>
                    <b>Flight Number:</b> ${this.flightLocation.flightNumber}<br/>
                    <b>Flight Vertical Speed:</b> ${this.flightLocation.speedVertical}<br/>
                    <b>Flight Horizontal Speed:</b> ${this.flightLocation.speedHorizontal}<br/>
                    <b>Flight Altitude:</b> ${this.flightLocation.altitude}<br/>
                    <b>Location:</b> ${marker.longitude}/${marker.latitude}<br/>
                    <b>Current ETA:</b> ${this.flightLocation?.eta ? 
                        moment(this.flightLocation.eta).format("DD MMMM yyyy HH:mm:ss") : 
                        "-"}`;
            }
            break;
        case "POD":
            description = `<b>Origin Location:</b> ${this.podPoint?.portName} (<b>${this.podPoint?.portId}</b>)`;
            break;
        case "POL":
            description = `<b>Destination Location:</b> ${this.polPoint?.portName} (<b>${this.polPoint?.portId}</b>)`;
            break;
        // Add other cases as needed
    }

    return description;
}

    // Added this function to remove all the pop ups on the map whenever hovering on different icons 10359.
    private removeAllMarker() {
        const popups = document.getElementsByClassName("mapboxgl-popup");
        if (popups.length) {
            while (popups.length > 0) {
                popups[0].parentNode.removeChild(popups[0]);
            }
        }
    }

    loadMap(filter: ISelectedFilters) {
        if (this.homeMap) {
            this.homeMap.mapGraphData({
                graphData: {
                    style: "mapbox://styles/mapbox/light-v10",
                    center: [15.238727594792325, 18.384546523159326],
                    zoom: 1,
                    minZoom: 1,
                    ctrlPos: "top-left",
                },
            });
            const map = this.homeMap.getChart();
            const defaultZoom = new MapboxGLButtonControl({
                className: "fas fa-brackets",
                title: "Reset to default zoom",
                eventHandler: () => {
                    this.fitToBox();
                },
            });
            map.addControl(defaultZoom, "top-left");
        }
    }
    private clearMap() {
        const map = this.homeMap.getChart();
        this.mapMarkers.map((marker: any) => {
            marker.remove();
        });

        if (map.getLayer("coveredRouteCircle")) {
            map.removeLayer("coveredRouteCircle");
        }
        if (map.getLayer("coveredRoute")) {
            map.removeLayer("coveredRoute");
        }
        if (map.getSource("coveredRoute")) {
            map.removeSource("coveredRoute");
        }
        if (map.getLayer("placeOfReceiptRoute")) {
            map.removeLayer("placeOfReceiptRoute");
        }

        if (map.getLayer("placeOfDeliveryRoute")) {
            map.removeLayer("placeOfDeliveryRoute");
        }
        if (map.getSource("placeOfDeliveryRoute")) {
            map.removeSource("placeOfDeliveryRoute");
        }
        if (map.getSource("placeOfReceiptRoute")) {
            map.removeSource("placeOfReceiptRoute");
        }
        if (map.getSource("pointSource")) {
            map.removeSource("pointSource");
        }

        if (map.getLayer("uncoveredRoute")) {
            map.removeLayer("uncoveredRoute");
        }
        if (map.getSource("uncoveredRoute")) {
            map.removeSource("uncoveredRoute");
        }

        if (map.getLayer("transhipmentRouteCircle")) {
            map.removeLayer("transhipmentRouteCircle");
        }
        if (map.getLayer("transhipmentRoute")) {
            map.removeLayer("transhipmentRoute");
        }
        if (map.getSource("transhipmentRoute")) {
            map.removeSource("transhipmentRoute");
        }
        this.mapMarkers = [];
    }

    ChangeRouteVisibility() {
        const map = this.homeMap.getChart();
        const routeLayer = map.getLayer("uncoveredRoute");
        if (routeLayer) {
            map.setLayoutProperty(
                "uncoveredRoute",
                "visibility",
                this.showPredictedRoute ? "visible" : "none"
            );
        }
    }


    checkInterSection(lng1: number, lng2: number) {
        if ((lng1 < 0 && lng2 > 0) || (lng1 > 0 && lng2 < 0)) {
            let diff = lng1 > lng2 ? lng1 - lng2 : lng2 - lng1;
            if (diff > 180) {
                this.intersection = true;
                return true;
            } else {
                this.intersection = false;
                return false;
            }
        }
    }
    getlatLongCorrection(coordinate, rightIntersection) {
        // Convert coordinate to number first
        const original = parseFloat(coordinate);
        const result = rightIntersection ? original + 360 : original - 360;
        return result;
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.destroyMap();
    }

    destroyMap() {
        if (this.homeMap) {
            try {
                const map = this.homeMap.getChart();
                if (map) {
                    this.clearMap();
                    map.remove();
                }
                this.homeMap = null;
                this.mapInitialized = false;
            } catch (error) {
                console.error('Error destroying map:', error);
            }
        }
    }
    //This method is used to set key reference value with concating 3 container numbers
    //if more than 1 container number is present
    setContainerKeyRefValue(containerDetails: any, keyRef: any) {
        this.containerNumbers = [];
        if (containerDetails.length > 0) {
            for (var index in containerDetails) {
                this.containerNumbers.push(
                    containerDetails[index][this.contanierRefKey]
                );
            }
            this.keyRef = {
                key: "containerNumber",
                label: "Container #(s)",
                value: this.containerNumbers.join(", "),
                shortLabel: "Container #(s)",
                keyIndex: 6,
            };
        } else {
            this.keyRef = {
                key: "bdpReferenceNumber",
                label: "Forwarder Ref No",
                value: this.shipmentInfo.generalInformation.bdpReferenceNo,
                shortLabel: "Forwarder Ref No",
                keyIndex: 1,
            };
        }

        //this.shipmentService.setContainerNumbers(this.containerNumbers);
    }

    fetchShipmentInfo(shipmentId: string): Observable<any> {
        this.isLiveTrackPendingOnly = false;
        this.isActiveShipment=false;
        return this.trackingService.getShipmentInfo(shipmentId).pipe(
            tap((res: any) => {
                //      console.log('API Response:', res.data.shipmentInformation);
                if (res.data) {
                    this.shipmentInfo.generalInfo =
                        res.data?.generalInfo;
                    this.badgeStatus =
                        res.data?.generalInfo.scheduleStatus;
                    this.badgeShipmentType =
                        res.data?.generalInfo?.shipmentStatusCode;
                    this.bdpReferenceNo = res.data?.generalInfo?.bdpRefno;
                    // Check if currentLocation and flightInformation are present and set badgeflightNumber accordingly
                    if (this.badgeShipmentType === 8) {
                        this.isDocsOnly = true;
                    }
                    if (
                        res.data?.generalInfo &&
                        res.data?.generalInfo?.activeFlight
                    ) {
                        this.badgeflightNumber =
                            res.data?.generalInfo?.activeFlight;
                    }
                    else if (
                        res.data.flightResponse &&
                        res.data?.flightResponse?.flightNumber

                    ) {
                        this.badgeflightNumber =
                            res.data?.flightResponse?.flightNumber;
                    }
                    else {
                        this.badgeflightNumber = "N/A"; // Set a default value if flight number is not available
                    }

                } else {
                    console.error(
                        "shipmentInformation is missing in the response"
                    );
                }
            }),
            catchError((error) => {
                console.error("Error fetching shipment info:", error);
                return throwError(error);
            })
        );
    }

    getShipmentTypeText(type: number): string {
        switch (type) {
            case 1:
                return "Not Started";
            case 2:
                return "In Transit";
            case 3:
                return "Arrived";
            case 5:
                return "Inactive";
            case 8:
                return "Doc Only";
            case 11:
                return "Live Track Pending";
            default:
                return "";
        }
    }

    getShipmentTypeClass(type: number): string {
        switch (type) {
            case 1:
                return "badge-not-started";
            case 2:
                return "badge-in-transit";
            case 3:
                return "badge-arrived";
            case 5:
                return "badge-inactive";
            case 8:
                return "badge-doc-only";
            case 11:
                return "badge-live-track-pending";
            default:
                return "";
        }
    }
}
